import React from 'react'
import CloseModalIcon from '../../../static/icons/close-menu-icon.svg'
import PropTypes from 'prop-types'

import { BodyScrollLock } from '../styled'
import {
  ModalBox,
  ModalBody,
  ModalIcon,
  ModalTitle,
  ModalSubtitle,
  ModalContent,
  ModalBackdrop,
  ModalClose,
  ModalFooter,
  CancelButton,
  ConfirmButton
} from './styles'

const WarningModal = ({
  visible,
  title,
  fullButton = true,
  iconSize,
  subtitle,
  children,
  onCancel,
  outlineCancelButton,
  onConfirm,
  type = 'info',
  cancelLabel,
  confirmLabel = 'Confirmar',
  icon,
  fullIcon,
  noPadding,
  dataTest,
  modalHeight,
  modalWidth,
  contentWidth,
  showClose = false,
  overflow,
  titleSize,
  onClose,
  overflowIncompletePet,
  outlineConfirmButton,
  subtitleMargin
}) => {
  return (
    <>
      <ModalBackdrop visible={visible} onClick={onClose || onCancel} data-test={`${dataTest}-backdrop`} />
      <ModalBox overflowIncompletePet={overflowIncompletePet} overflow={overflow} visible={visible} type={type} data-test={dataTest} modalHeight={modalHeight} modalWidth={modalWidth}>
        {showClose && (
          <ModalClose onClick={onCancel} type={type}>
            <CloseModalIcon />
          </ModalClose>
        )}
        <ModalBody contentWidth={contentWidth} type={type}>
          {icon && <ModalIcon type={type} fullIcon={fullIcon} style={iconSize && { width: iconSize, height: iconSize }} src={icon} />}
          <ModalTitle titleSize={titleSize} data-test={`${dataTest}-title`} type={type}>{title}</ModalTitle>
          {subtitle && <ModalSubtitle subtitleMargin={subtitleMargin} data-test={`${dataTest}-subtitle`}>{subtitle}</ModalSubtitle>}
          {children && <ModalContent data-test={`${dataTest}-content`} hasTitle={!!title} type={type}>{children}</ModalContent>}
        </ModalBody>
        <ModalFooter contentWidth={contentWidth}>
          {(onCancel && cancelLabel) && <CancelButton onlyCancel={!!confirmLabel} outlineCancelButton={outlineCancelButton} fullButton={fullButton} data-test={`${dataTest}-button-cancel`} onClick={onCancel}>{cancelLabel}</CancelButton>}
          {(onConfirm && confirmLabel) && <ConfirmButton outlineConfirmButton={outlineConfirmButton} fullButton={fullButton} data-test={`${dataTest}-button-confirm`} onClick={onConfirm}>{confirmLabel}</ConfirmButton>}
        </ModalFooter>
      </ModalBox>
      <BodyScrollLock active={visible} />
    </>
  )
}

export default WarningModal

WarningModal.propTypes = {
  visible: PropTypes.bool,
  title: PropTypes.string,
  fullButton: PropTypes.bool,
  iconSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  subtitle: PropTypes.string,
  children: PropTypes.node,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
  type: PropTypes.oneOf(['info', 'action', 'warning', 'danger', 'success']),
  cancelLabel: PropTypes.node,
  confirmLabel: PropTypes.node,
  icon: PropTypes.string,
  dataTest: PropTypes.string,
  modalHeight: PropTypes.number,
  modalWidth: PropTypes.number,
  contentWidth: PropTypes.number,
  showClose: PropTypes.bool,
  titleSize: PropTypes.string,
  onClose: PropTypes.func,
  subtitleMargin: PropTypes.string
}
